import React, { useEffect, useState } from "react";
import BlogCard from "./BlogCard";
import { Link } from "react-router-dom";
import SEO from "../../config/SEO";
import { blogListUrl } from "../../utils/Universalfunctions";

const BlogList = () => {
     const [data, setData] = useState([]);

     // --- Pagination States ---
     const [currentPage, setCurrentPage] = useState(1);
     const postsPerPage = 9;

     useEffect(() => {
          fetch(blogListUrl)
               .then(res => res.json())
               .then(result => setData(result.reverse()));
     }, []);

     // --- Pagination Logic ---
     const indexOfLastPost = currentPage * postsPerPage;
     const indexOfFirstPost = indexOfLastPost - postsPerPage;
     const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);
     const totalPages = Math.ceil(data.length / postsPerPage);

     const paginate = (pageNumber) => {
          setCurrentPage(pageNumber);
          window.scrollTo(0, 0);
     };


     const [activeIndex, setActiveIndex] = useState(null);

     const faqs = [
          {
               question: "What is Prompt Engineering and why does it matter?",
               answer: "Prompt Engineering is the skill of crafting precise instructions for AI models like ChatGPT or Claude. It helps you get accurate, high-quality results that standard queries often miss."
          },
          {
               question: "What kind of AI tools do you cover on HeyPrompt?",
               answer: "We focus on practical AI tools for productivity, content automation platforms like Make and Zapier, and advanced prompt engineering frameworks for real-world projects."
          },
          {
               question: "Are the AI workflows shared here free to use?",
               answer: "Yes, most of our prompts and automation workflows are designed to work with free or entry-level AI plans so that anyone can start learning immediately."
          },
          {
               question: "Which AI model is best for prompt engineering in 2026?",
               answer: "It depends on your goal. Claude 3.5 Sonnet is currently a favorite for coding, while GPT-4o remains highly effective for creative content and complex reasoning."
          },
          {
               question: "How can I start with content automation?",
               answer: "You can begin by exploring our 'Automation' category. We provide step-by-step guides on connecting AI with your daily apps to save hours of manual work."
          },
          {
               question: "Do I need coding skills to use these AI tools?",
               answer: "Not at all. We prioritize 'No-Code' solutions. As long as you understand basic logic, you can build powerful AI systems using the guides on this blog."
          },
          {
               question: "What is the difference between custom GPTs and standard AI?",
               answer: "Custom GPTs are tailored with specific data and instructions for a particular task, making them more efficient than generic AI for specialized work."
          },
          {
               question: "How can I make my AI prompts more effective?",
               answer: "To optimize prompts, use techniques like 'Persona Setting' (giving AI a role) and providing 'Contextual Examples' to guide the output style."
          },
          {
               question: "What is the future of AI in content creation?",
               answer: "The future is collaborative. AI will handle repetitive tasks like data gathering and formatting, while humans focus on creative strategy and final editing."
          },
          {
               question: "How do I stay updated with the latest AI trends?",
               answer: "We constantly update HeyPrompt with new workflows and tool reviews. Bookmark our blog or follow our latest posts to never miss a major AI update."
          }
     ];


     const toggleFAQ = (index) => {
          setActiveIndex(activeIndex === index ? null : index);
     };


     return (
          <>
               <SEO
                    title="AI Prompts Blog (2026) - Guides, Tutorials & Prompt Engineering Tips"
                    description="Read the HeyPrompt blog for practical guides on AI prompts, prompt engineering, ChatGPT, Gemini, AI image generation, automation workflows, and productivity tools. Learn how to use AI prompts to create better content, images, and digital products."
                    keywords="ai prompts blog, prompt engineering blog, chatgpt prompt guides, gemini ai tutorials, ai prompt tutorials, ai content creation guides, ai prompt tips, ai tools tutorials, prompt engineering examples"
                    canonicalPath="/blogs"
               />

               <div className="__heyprompt-blog">
                    <div className="__container">
                         <div className="blog-list-page">
                              <nav aria-label="breadcrumb" className="breadcrumb-kls333">
                                   <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Blogs</li>
                                   </ol>
                              </nav>

                              <h1 className="page-title"> +{data.length} AI Prompts Blog (2026) – Guides, Tutorials & Prompt Engineering Tips</h1>

                              <p className="page-paragraph"> Read the HeyPrompt blog for practical guides on AI prompts, prompt engineering, ChatGPT, Gemini, AI image generation, automation workflows, and productivity tools. Learn how to use AI prompts to create better content, images, and digital products.</p>

                              <div className="top-blogs-hey">
                                   <div className="row">
                                        <div className="col-md-6">
                                             <div className="top-blogs-hey-image">
                                                  <Link to={`${window.location.origin}/blog/heyprompt-product-hunt-launch-breakdown`} className="stretched-link">
                                                       <img src={'https://res.cloudinary.com/dqwbmkrm8/image/upload/v1772594698/Gemini_Generated_Image_j2zqm6j2zqm6j2zq_rq5ddl.png'} alt={'HeyPrompt Product Hunt Launch Explained'} />
                                                  </Link>
                                             </div>
                                        </div>

                                        <div className="col-md-6">
                                             <div className="top-blogs-hey-information">
                                                  <span className="blog-section__category">AI / Startup Launch / Product Hunt </span> <br />
                                                  <p className="dateld">Update: 2026-03-04 </p>
                                                  <h3 className="blog-section__title"> HeyPrompt Product Hunt Launch Explained: Building the Future of the AI Prompt Marketplace </h3>
                                                  <div className="blog-section__description" >HeyPrompt has officially launched on Product Hunt, marking an important milestone in the growth of the AI prompt marketplace industry. As AI tools like ChatGPT, Gemini, Claude, and Grok become essenti.... </div>

                                                  <Link to={`${window.location.origin}/blog/heyprompt-product-hunt-launch-breakdown`} className="link-arrow">Explore Full Blog ↗</Link>
                                             </div>
                                        </div>
                                   </div>


                              </div>


                              <div className="row row-gap-4 pb-5">
                                   {data.length === 0 ? (
                                        <div className="col-12 text-center">
                                             <h5>Blogs not found, please wait...</h5>
                                        </div>
                                   ) : (
                                        currentPosts
                                             .filter(post =>
                                                  post.status === "show"
                                                  // post.slug !== "heyprompt-product-hunt-launch-breakdown"
                                             )
                                             .map((post, i) => (
                                                  <BlogCard key={i} post={post} />
                                             ))
                                   )}
                              </div>

                              {data.length > postsPerPage && (
                                   <nav className="mt-5">
                                        <ul className="pagination justify-content-center flex-wrap">
                                             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                  <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                                             </li>

                                             {[...Array(totalPages)].map((_, index) => (
                                                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                       <button className="page-link" onClick={() => paginate(index + 1)}>
                                                            {index + 1}
                                                       </button>
                                                  </li>
                                             ))}

                                             <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                  <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                                             </li>
                                        </ul>
                                   </nav>
                              )}

                              <div className="faq-section">
                                   <div className="container">
                                        <div className="row justify-content-center">
                                             <div className="col-12">
                                                  <div className="text-center mb-5">
                                                       <h2 className="faq-title">Frequently Asked Questions</h2>
                                                       <p>AI, Prompts aur Automation se jude har sawal ka jawab yahan milega.</p>
                                                  </div>

                                                  <div className="faq-container">
                                                       {faqs.map((faq, index) => (
                                                            <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
                                                                 <div className="faq-question" onClick={() => toggleFAQ(index)}>
                                                                      <span>{faq.question}</span>
                                                                      <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
                                                                 </div>
                                                                 <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
                                                                      <p>{faq.answer}</p>
                                                                 </div>
                                                            </div>
                                                       ))}
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>


                              <section className="login-cta-container py-5">
                                   <div className="container">
                                        <div className="login-box-wrapper text-center">
                                             <div className="glow-effect"></div>
                                             <h2 className="login-cta-title">Unlock Full Access</h2>
                                             <p className="login-cta-desc">
                                                  Join 5,000+ creators and developers. Login to save your favorite prompts,
                                                  access exclusive workflows, and get notified about new AI tools.
                                             </p>
                                             <div className="login-btn-group">
                                                  <Link to="/login" className="btn-login-primary">
                                                       Get Started Now
                                                       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short ms-2" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                                                       </svg>
                                                  </Link>
                                             </div>
                                             <span className="login-subtext">No credit card required. It's free!</span>
                                        </div>
                                   </div>
                              </section>

                         </div>
                    </div>
               </div>
          </>
     );
};

export default BlogList;
